import { RiServerFill } from "react-icons/ri";
import {
  COSTUM,
  DATE,
  SELECT,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { HISOBOT } from "../../Component/Sidebar/PageTypes";
import PrintBtn from "./components/PrintBtn";
import Refresh from "./components/Refresh";
const MijozlarQoldigi = {
  title: "Мижозлар қолдиги",
  path: "/hisobot/mijozlar-qoldigi",
  icon: <RiServerFill></RiServerFill>,
  type: HISOBOT,
  allData: [{ value: "mijoz_id", prop: "mijozlar", get: "fio" }],
  hisobotActions: [
    {
      grid: "1fr 3fr 1fr",
      inputs: [
        {
          label: "Сана",
          name: "sana3",
          type: DATE,
        },
        {
          label: "Мижозлар",
          name: "mijoz_id",
          type: SELECT,
          allData: {
            type: "mijozlar",
            key: "Id",
            text: "fio",
          },
        },
        {
          type: COSTUM,
          component: (
            <div
              style={{ display: "flex", gridGap: "10px", alignItems: "center" }}
            >
              <Refresh text="Янгилаш"></Refresh>
              <PrintBtn></PrintBtn>
            </div>
          ),
        },
      ],
    },
  ],
};
export default MijozlarQoldigi;
